import { actions as sentActions } from '~/sent/reducer';
import { actions as draftsActions } from '~/drafts/reducer';
import { actions as storiesActions } from '~/stories/reducer';
import { actions as remindersActions } from '~/past-reminders/reducer';
import { actions as campaignsActions } from '~/campaign/reducer';
import { actions as composerPopoverActions } from '~/composer-popover/reducer';
import { actions as storyGroupComposerActions } from '~/story-group-composer/reducer';
import { actionTypes } from './reducer';

export default ({ dispatch, getState }) =>
  (next) =>
  (action) => {
    next(action);
    const { page } = getState().modals;

    switch (action.type) {
      case actionTypes.CLOSE_COMPOSER_AND_CONFIRMATION_MODAL:
        switch (page) {
          case 'stories':
            dispatch(storyGroupComposerActions.resetStoryGroupState());
            dispatch(storiesActions.handleCloseStoriesComposer());
            break;
          case 'pastReminders':
            dispatch(storyGroupComposerActions.resetStoryGroupState());
            dispatch(remindersActions.handleComposerCreateSuccess());
            dispatch(remindersActions.handleCloseStoriesComposer());
            break;
          case 'sent':
            dispatch(sentActions.handleComposerCreateSuccess());
            break;
          case 'drafts':
          case 'awaitingApproval':
            dispatch(draftsActions.handleComposerCreateSuccess());
            break;
          case 'campaigns':
            dispatch(campaignsActions.handleCloseComposer());
            break;
          case 'pendingTiktok':
          case 'calendar':
          case 'queue':
            dispatch(composerPopoverActions.hideComposer());
            break;
          default:
            break;
        }
        break;
      default:
        break;
    }
  };
